import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type WizardData = {
  name: string;
  email: string;
  groom: string;
  groom_pronoun: 'he' | 'she' | 'they';
  bride: string;
  bride_pronoun: 'he' | 'she' | 'they';
  known_since: string;
  relationship: string;
  memories: { content: string }[];
  style: string;
};

type WizardStore = {
  data: WizardData;
  setData: (data: Partial<WizardData>) => void;
};

const defaultData: WizardData = {
  name: '',
  email: '',

  groom: '',
  groom_pronoun: 'he',
  bride: '',
  bride_pronoun: 'she',

  relationship: '',
  known_since: '',
  memories: [{ content: '' }],

  style: '',
};

export const useWizardStore = create(
  persist<WizardStore>(
    (set) => ({
      data: defaultData,
      setData: (data: Partial<WizardData>) =>
        set((state) => ({ data: { ...state.data, ...data } })),
    }),
    { name: 'wizardStore', version: 1 },
  ),
);
